import * as Factory from 'factory.ts'
import faker from 'faker'
import moment from 'moment'

import { type CustomField, type CustomFieldValue } from '../../models'
import { CustomFieldTypes } from '../../models/enums/CustomField'

export const CustomFieldMock = Factory.Sync.makeFactory<CustomField>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each((index) => `${faker.random.word()}_${index}`),
  content_type: faker.random.number(),
  default_value: '',
  is_required: false,
  field_choices: [...faker.random.words(5).split(' ')],
  field_type: CustomFieldTypes.TEXT,
  field_label: Factory.each((index) => `${faker.random.word()}_${index}`),
  is_active: true,
}).withDerivation1(['field_type'], 'field_choices', (fieldType) => {
  return fieldType === CustomFieldTypes.DROPDOWN
    ? faker.lorem.words(5).split(' ')
    : []
})

export const CustomFieldValueMock = Factory.Sync.makeFactory<CustomFieldValue>({
  id: Factory.each(() => faker.random.number()),
  value: Factory.each(() => faker.lorem.word()),
  field: Factory.each(() => CustomFieldMock.build()),
}).withDerivation1(['field'], 'value', (field) => {
  if (field.field_type === CustomFieldTypes.DATE) {
    return moment().toISOString()
  } else if (field.field_type === CustomFieldTypes.CHECKBOX) {
    return faker.random.boolean()
  } else {
    return faker.lorem.word()
  }
})

export const CustomFieldFormValueMock =
  Factory.Sync.makeFactory<CustomFieldValue>({
    id: Factory.each(() => faker.random.number()),
    value: faker.lorem.word(),
    field: Factory.each(() => CustomFieldMock.build()),
  }).withDerivation1(['field'], 'value', (field) => {
    if (field.field_type === CustomFieldTypes.DATE) {
      return moment()
    } else if (field.field_type === CustomFieldTypes.CHECKBOX) {
      return faker.random.boolean()
    } else {
      return faker.lorem.word()
    }
  })
